import * as actions from "store/actions/user/detail";
import IUser from "Types/User";

export interface UserDetailState {
	item: IUser | null;
	loading: boolean;
	errors: any;
}

const initialState: UserDetailState = {
	item: null,
	loading: false,
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.GET_USER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_USER_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.GET_USER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
